import { Component, ChangeDetectionStrategy } from '@angular/core';

import { Controllers } from '@shared/core/controllers';

import { AuthTypeComponent } from '../auth-type.shared.component';

@Component({
    selector: 'shared-auth-for-birthday-rewards',
    templateUrl: './auth-for-birthday-rewards.shared.component.html',
    styleUrls: ['./auth-for-birthday-rewards.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthForBirthdayRewardsComponent extends AuthTypeComponent {
    constructor(
        public controllers: Controllers,
    ) {
        super(controllers);
    }
}
